
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const NotFoundState: React.FC = () => {
  return (
    <Card className="max-w-3xl mx-auto">
      <CardContent className="p-6">
        <div className="text-center py-8">
          <AlertTriangle className="mx-auto h-12 w-12 text-yellow-500 mb-4" />
          <h2 className="text-2xl font-semibold mb-2 text-foreground">Invoice Not Found</h2>
          <p className="text-muted-foreground">The requested invoice could not be found.</p>
          <Button className="mt-6" variant="outline" asChild>
            <Link to="/dashboard">Return to Dashboard</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotFoundState;
